export const anchorErrorKeyPrefix = (scheduleIndex, anchorIndex) =>
  `schedules.${scheduleIndex}.anchors.${anchorIndex}.`

/** Drop stale save-validation errors when the user edits an anchor field. */
export const clearAnchorErrorsForUpdate = (errors, scheduleIndex, anchorIndex, patch, previousType) => {
  if (!errors || scheduleIndex < 0 || anchorIndex < 0 || !patch) return errors

  const prefix = anchorErrorKeyPrefix(scheduleIndex, anchorIndex)
  const typeChanged = patch.type != null && patch.type !== previousType
  const keysToRemove = typeChanged
    ? Object.keys(errors).filter(key => key.startsWith(prefix))
    : [
        ...(patch.type !== undefined ? [`${prefix}type`] : []),
        ...(patch.instanceId !== undefined || patch.instanceIds !== undefined
          ? [`${prefix}instanceId`]
          : []),
        ...(patch.visitStatus !== undefined ? [`${prefix}visitStatus`] : []),
        ...(patch.instrumentEvent !== undefined ? [`${prefix}instrumentEvent`] : []),
        ...(patch.offset !== undefined ? [`${prefix}offset`] : []),
        ...(patch.fixedDate !== undefined ? [`${prefix}fixedDate`] : []),
      ].filter(key => errors[key] != null)

  if (!keysToRemove.length) return errors

  const next = { ...errors }
  keysToRemove.forEach(key => {
    delete next[key]
  })
  return next
}
